// extracted by mini-css-extract-plugin
module.exports = {"tabs__content":"styles_tabs__content__SA5Vo","tabs__svg__text":"styles_tabs__svg__text__MpUBH","pulse":"styles_pulse__5DWcj","jump":"styles_jump__7h_lK"};